




































































































import { Vue, Component } from 'vue-property-decorator'
import { APIMenuItem } from '@/models/api/menu-item.model'

@Component
export default class MenuItemForm extends Vue {
    loading = true

    cardTitle = ''

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: {[key: string]: any} = {}
    formValid = false
    formRules = {
        extraClasses: [
            (v: string) => {
                if (v) {
                    return (v.length <= 100) || 'Icon must be less than 100 characters'
                } else {
                    return true
                }
            }
        ],
        menuTitle: [
            (v: string) => !!v || 'Title is required',
            (v: string) => (v && v.length <= 50) || 'Name must be less than 50 characters'
        ],
        icon: [
            (v: string) => {
                if (v) {
                    return (v.length <= 50) || 'Icon must be less than 50 characters'
                } else {
                    return true
                }
            }
        ],
        priority: [
            (v: number) => {
                let bool = false
                if (v || v === 0) bool = true
                return bool || 'Priority is required'
            }
        ],
        href: [
            (v: string) => {
                if (v) {
                    return (v.length <= 255) || 'Field must be less than 255 characters'
                } else {
                    return true
                }
            }
        ],
        permissions: [
            (v: string) => !!v || 'Permission is required'
        ],
        required: [
            (v: string) => !!v || 'This field is required'
        ]
    }

    formModel: { permissions: {value: number}[]; rootMenuItems: object[] } = {
        permissions: [],
        rootMenuItems: [
            {
                text: 'Root Item',
                value: null
            }
        ]
    }

    async mounted () {
        await this.getPermissions()
        await this.getRootItems()
        if (this.$route.params.action) {
            switch (this.$route.params.action) {
            case 'edit':
                this.cardTitle = 'Edit Item'
                this.getItemById()
                break
            case 'add':
                this.cardTitle = 'Add Item'
                this.loading = false
                break
            }
        }
    }

    getPermissions () {
        return new Promise(resolve => {
            this.$store.dispatch('getPermissions')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.permissions = this.$store.state.PermissionsStore.permissions.map((p: {permissionName: string; permissionId: number}) => {
                            return {
                                text: p.permissionName,
                                value: p.permissionId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getRootItems () {
        return new Promise(resolve => {
            this.$store.dispatch('getMenuItem')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.rootMenuItems = [ ...this.formModel.rootMenuItems, ...this.$store.state.MenuItemStore.menuItems.map((menuItem: APIMenuItem) => {
                            return {
                                text: menuItem.menuItemTitle,
                                value: menuItem.menuItemId
                            }
                        }) ]
                        resolve()
                    }
                })
        })
    }

    getItemById () {
        this.loading = true
        this.$store.dispatch('getMenuItemById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store?.state?.MenuItemStore?.menuItemForm || {}
                    if (this.formData.menuItemParentId) {
                        this.formData.menuItemParentId = this.formData.menuItemParentId.menuItemId
                    }

                    this.formData.permissionId = this.formModel.permissions.find(p => p.value === this.formData.permissionId.permissionId)
                    if (!this.formData.permissionId) {
                        this.$store.commit('reportError', { code: 1000, message: 'Error, cannot find item permission :(' })
                    }
                }
                this.loading = false
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()

        if (!this.formValid) return

        this.formData.menuId = this.$route.params.parent
        this.formData.url = ''

        if (this.formData.permissionId.value) this.formData.permissionId = this.formData.permissionId.value
        if (!this.formData.menuItemEnabled) this.formData.menuItemEnabled = 1
        if (!this.formData.menuItemParentId) this.formData.menuItemParentId = null
        if (!this.formData.menuItemUrl) this.formData.menuItemUrl = null

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editMenuItem', this.formData)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.getItemById();
                        (this.$refs.form as Vue & { resetValidation: () => boolean }).resetValidation()
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        // this.$emit('reloadData')
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createMenuItem', this.formData)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.formData = {};
                        (this.$refs.form as Vue & { resetValidation: () => boolean }).resetValidation()
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        // this.$emit('reloadData')
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
